import React, { useState } from 'react'
import useRequest from "hooks/useRequest";
import movieAPI from "apis/movieAPI";
import { useParams } from 'react-router-dom';
import { Content } from 'antd/lib/layout/layout';
import { Breadcrumb, DatePicker, Form, notification, Select } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import { useEffect } from 'react';
import { fireEvent } from '@testing-library/react';


const CreateShowTime = () => {

    const [edit, setEdit] = useState(null)
    const [change, setChange] = useState(false)

    const { data: cinema } = useRequest(() => movieAPI.getCinema(), { refreshDeps: [change] })
    const { data: movie, isLoading, error } = useRequest(() => movieAPI.getMovieDetails(movieId), { refreshDeps: [change] })
    const { data: subCinema } = useRequest(() => movieAPI.getSubCinema(edit?.maHeThongRap), { refreshDeps: [edit?.maHeThongRap] })

    useEffect(() => {
        setEdit({ tenHeThongRap: cinema?.[0].tenHeThongRap, maHeThongRap: cinema?.[0].maHeThongRap })



    }, [cinema])
    useEffect(() => {
        setEdit({ ...edit, tenCumRap: subCinema?.[0].tenCumRap })

    }, [subCinema])


    useEffect(() => {

        const name = cinema?.find((cine) => { return cine.tenHeThongRap === edit?.tenHeThongRap })
        console.log(name)
        setEdit({
            ...edit, maHeThongRap: name?.maHeThongRap
        }



        )
    }, [edit?.tenHeThongRap])


    useEffect(() => {
        const name = subCinema?.find((cine) => { return cine.tenCumRap === edit?.tenCumRap })
        setEdit({ ...edit, maRap: name?.danhSachRap, maRapDangChon: name?.danhSachRap[0].maRap })
        setValue("maRap", name?.danhSachRap[0].maRap)


    }, [edit?.tenCumRap])


    // {
    //     if !) {
    //        isLoading, console.log(cinema?.[0].tenHeThongRap);
    //     }

    // }



    const [imgPreview, setImgPreview] = useState("");

    const { form } = Form.useForm()

    const { movieId } = useParams()

    const { register, handleSubmit, setValue, control } = useForm({
        defaultValues: {
            maPhim: "",
            maRap: "",
            giaVe: "",
            ngayKhoiChieu: "",
        },
        mode: "onTouched",
    });



    const onSubmit = async (values) => {
        try {
            // await handleAddMovie(values);
            // // Thành công: gọi notification
            console.log(values)
            notification.success({
                message: "Tạo lịch chiếu thành công"
            })
            // Redirect về trang MovieList


        } catch (error) {
            // Thất bại: gọi notification hiển thị error
            notification.error({
                message: "Tạo lịch chiếu thất bại ",
                description: error,
            })
        }
    };

    const handleSelectBox = (e) => {
        console.log(e)
        setEdit((pre) => {
            return { ...pre, tenHeThongRap: e };
        });


    }


    const handleSelectBox2 = (e) => {
        console.log(e)
        setEdit((pre) => {
            return { ...pre, tenCumRap: e };
        });


    }

    const handleSelectBox3 = (e) => {
        console.log(e)
        setEdit((pre) => {
            return { ...pre, maRapDangChon: e };
        });
    }


    return (
        <>
            <Content style={{ margin: '0 16px' }}>
                <Breadcrumb style={{ margin: '16px 0' }}>

                </Breadcrumb>

                <h1>Tạo lịch chiếu - {movie?.tenPhim}</h1>
                <img src={movie?.hinhAnh} alt="preview" className='d-flex mx-auto mb-3 h-25 w-25' />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='d-flex mb-3 w-75 mx-auto align-items-center'>
                        <label className='form-label  ' style={{ width: "10em" }} >Hệ thống rạp:</label>
                        <Select value={edit?.tenHeThongRap}
                            onChange={(value) => handleSelectBox(value)} >
                            {cinema?.map((e) => {
                                return <Select.Option value={e.tenHeThongRap} > {e.tenHeThongRap}</Select.Option>
                            })}
                            {/* <Select.Option value='KhachHang'>KhachHang</Select.Option>
                            <Select.Option value='QuanTri'>QuanTri</Select.Option> */}
                        </Select>
                    </div>
                    <div className='d-flex mb-3 w-75 mx-auto align-items-center'>
                        <label className='form-label  ' style={{ width: "10em" }} >Cụm rạp:</label>
                        <Select
                            value={edit?.tenCumRap}
                            onChange={(value) => handleSelectBox2(value)} >
                            {subCinema?.map((e) => {
                                return <Select.Option value={e.tenCumRap} > {e.tenCumRap}</Select.Option>
                            })}
                            {/* <Select.Option value='KhachHang'>KhachHang</Select.Option>
                            <Select.Option value='QuanTri'>QuanTri</Select.Option> */}
                        </Select>
                    </div>
                    <div className='d-flex mb-3 w-75 mx-auto align-items-center'>
                        <label className='form-label  ' style={{ width: "10em" }} >Mã rạp:</label>
                        <Controller control={control} name="maRap"

                            render={({ field, fieldState = { error } }) => (
                                <Select
                                    value={edit?.maRapDangChon}
                                    onChange={(value) => {return handleSelectBox3(value), field.onChange(value) }} >
                                    {edit?.maRap?.map((e) => {
                                        return <Select.Option value={e.maRap} > {e.maRap}</Select.Option>
                                    })}


                                </Select>
                            )}

                        />
                    </div>
                    <div className='d-flex mb-3 w-75 mx-auto align-items-center'>
                        <label className='form-label  ' style={{ width: "10em" }} htmlFor="biDanh">Bí danh:</label>

                        <input className='form-control' type="text" id="biDanh" placeholder="Bí Danh" {...register("biDanh")} />
                    </div>



                    <div className='d-flex mb-3 w-75 mx-auto align-items-center flex-wrap'>

                        <Controller
                            name='ngayKhoiChieu'
                            control={control}
                            rules={{ required: { value: true, message: 'Ngày khởi chiếu không được để trống' } }}

                            render={({ field, fieldState: { error } }) => (
                                <Form.Item
                                    label="Ngày khởi chiếu"
                                    validateStatus={error ? "error" : ""}
                                    help={error?.message}
                                >
                                    <DatePicker
                                        style={{ borderRadius: '5px', marginLeft: '8px' }}
                                        format={"DD/MM/YYYY"}
                                        placeholderText="Select date"
                                        onChange={(e) => {
                                            const d = new Date(e).toLocaleDateString('fr-FR');
                                            field.onChange(d);
                                        }}
                                    // selected={field.value}
                                    />
                                </Form.Item>
                            )}

                        />
                    </div>


                    <button>Thêm Phim</button>
                </form>
            </Content>

        </>
    );
};

export default CreateShowTime